import React from 'react';
import {Spinner} from 'react-bootstrap';

const LargeSpinner = props => {
    return (<Spinner animation="border" {...props} />);
};

export default LargeSpinner;
